module.exports = __webpack_public_path__ + "static/media/agatlogo.63b16ed0.png";


//////////////////
// WEBPACK FOOTER
// ./src/photos/agatlogo.png
// module id = 375
// module chunks = 0